import { render, staticRenderFns } from "./LkTableBodyRow.vue?vue&type=template&id=1fb65228&"
import script from "./LkTableBodyRow.vue?vue&type=script&lang=js&"
export * from "./LkTableBodyRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports